import React, { useState, useEffect } from 'react';
import { Form, Button, Loader } from 'semantic-ui-react';
import toast from 'react-hot-toast';

import { createRfi, updateRfi } from '~/api/requestForInformation';
import { CreateRfiRequest } from '~/types/requestForInformation';
import { useProjectContext, usePortfolioContext } from '~/hooks';

import '../styles.scss';

interface RfiFormProps {
  rfiToEdit?: any; // TODO: type for this
  refreshList: () => void;
  closeModal: () => void;
}

const RfiForm: React.FC<RfiFormProps> = ({ rfiToEdit, refreshList, closeModal }) => {

  const [formData, setformData] = useState<any>(); // TODO: type for this
  const [isProcessing, setIsProcessing] = useState(false);
  const { project } = useProjectContext();
  const { portfolio } = usePortfolioContext();

  useEffect(() => {
    if (rfiToEdit) {
      setformData({
        name: rfiToEdit.name,
        description: rfiToEdit.description,
      });
    } else {
      setformData({
        name: '',
        description: '',
      });
    }
  }
    , [rfiToEdit]);

  const updateFormValue = (e: any) => {
    const { name, value } = e.target;
    setformData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitForm = () => {
    if (!formData?.name || !formData?.description) {
      toast.error('Please fill out all required fields.');
      return;
    }
    if (rfiToEdit) {
      updateExistingRfi();
    } else {
      createNewRfi();
    }
  };

  const createNewRfi = async () => {
    if (isProcessing) return; // Prevent multiple submissions
    try {
      setIsProcessing(true);
      const request: CreateRfiRequest = {
        name: formData.name,
        description: formData.description,
        input_type: 'text'
      };
      if (portfolio) {
        request.portfolio_id = portfolio.id;
      } else {
        request.project_id = project.id;
      }
      await createRfi(request);
      toast.success('Request for information created successfully');
      refreshList();
      closeModal();
      setIsProcessing(false);
    } catch (error) {
      toast.error('Failed to submit form.');
      setIsProcessing(false);
    }
  };

  const updateExistingRfi = async () => {
    if (isProcessing) return; // Prevent multiple submissions
    try {
      setIsProcessing(true);
      await updateRfi(rfiToEdit.id, {
        name: formData.name,
        description: formData.description,
      });
      toast.success('Request for information updated successfully');
      refreshList();
      closeModal();
      setIsProcessing(false);
    }
    catch (error) {
      toast.error('Failed to update request for information.');
      setIsProcessing(false);
    }
  };

  return (
    <Form
      className="rfi-form"
      onSubmit={e => {
        e.preventDefault();
        submitForm();
      }}
        >
      <Form.Input
        label="Name"
        name="name"
        placeholder="Type name here..."
        value={formData?.name || ''}
        onChange={updateFormValue}
        required
        maxLength={50}
      />
      <Form.TextArea
        label="Information Requested"
        name="description"
        placeholder="Ask the question to be answered here..."
        value={formData?.description || ''}
        onChange={updateFormValue}
        required
        maxLength={300}
      />
      <div className="form-actions">
        <Button className="button primary outlined" onClick={closeModal} type="button">
          Cancel
        </Button>

        <Button primary type="submit" style={{ display: 'flex', alignItems: 'center' }}>
          {isProcessing ? (
            <span>
              <span>Saving</span>
              <Loader active inverted inline size="mini" style={{ marginLeft: '8px' }} />
            </span>
          ) : (
            <span>Save</span>
          )}
        </Button>


      </div>
    </Form>
  );
};

export default RfiForm;